import { EnmState } from "./enums";

export abstract class AEntity {
    id: number;
    state: EnmState;
    createdBy: number;
    createdAt: Date;
    updatedBy: number;
    updatedAt: Date;
    deletedBy: number;
    deletedAt: Date;

    convertArray<T>(type: new () => T, array: any[]): T[] {
        if (array && array.length) {
            if (!(array[0] instanceof type)) {
                return array.map(v => this.convert(type, v));
            }
        }
        return array;
    }

    convert<T>(type: new () => T, value: T): T {
        let model: T = new type();
        Object.assign(model, value);
        return model;
    }

    toJSON() {
        const proto = Object.getPrototypeOf(this);
        const jsonObj: any = Object.assign({}, this);

        Object.entries(Object.getOwnPropertyDescriptors(proto))
            .filter(([key, descriptor]) => typeof descriptor.get === 'function')
            .map(([key, descriptor]) => {
                if (descriptor && key[0] !== '_') {
                    try {
                        const val = (this as any)[key];
                        jsonObj[key] = val;
                    } catch (error) {
                        console.error(`Error calling getter ${key}`, error);
                    }
                }
            });

        return jsonObj;
    }
}
